<template>
  <v-form ref="form" v-bind="this.$attrs" class="mb-6">
    <v-row>
      <v-col cols="12" sm="6" md="12">
        <v-text-field
          v-model="stt"
          label="Tên tuyến xe"
          outlined
          required
          dense
          hide-details
          class="required font-size"
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    oldData: {
      type: Object
    }
  },
  data() {
    return {
      stt: ''
    }
  },
  methods: {
    getData() {
      if (this.$refs.form.validate()) {
        return {
          stt: this.stt
        }
      }
    }
  },
  watch: {
    oldData: {
      handler(value) {
        if (value) {
          this.stt = this.oldData.stt
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style></style>
